import { render, staticRenderFns } from "./FormQuestionList.vue?vue&type=template&id=bd2a5bbe&scoped=true"
import script from "./FormQuestionList.vue?vue&type=script&lang=js"
export * from "./FormQuestionList.vue?vue&type=script&lang=js"
import style0 from "./FormQuestionList.vue?vue&type=style&index=0&id=bd2a5bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2a5bbe",
  null
  
)

export default component.exports